function combineQuestionsAndAnswers(questions, userAnswers) {
    return questions.map((question) => {
        const answer = userAnswers[question.id.toString()]

        if (answer === undefined || answer === null) {
            return { [question.questionText]: null }
        }

        if (question.type === "single_select" && typeof answer === "string") {
            const options = JSON.parse(question.questionOptions || "[]")
            const selectedOption = options.find(
                (option) => option.id === Number(answer),
            )
            return {
                questionText: question.questionText,
                answer: selectedOption ? selectedOption.label : null,
            }
        }

        if (question.type === "multi_select" && Array.isArray(answer)) {
            const options = JSON.parse(question.questionOptions || "[]")
            const selectedOptions = options
                .filter((option) => answer.includes(option.id))
                .map((option) => option.label)

            return {
                questionText: question.questionText,
                answer: selectedOptions.join(", "),
            }
        }

        // Caso seja tipo texto ou outra resposta direta
        return {
            questionText: question.questionText,
            answer: answer,
        }
    })
}

export default combineQuestionsAndAnswers
